//奥运会 full
import PlatfromCSMeetOlympicGamesFull from '@containers/platfrom_compreSportsMeet/olympicGamesFull_SOG.vue'

export default {
  PlatfromCSMeetOlympicGamesFull,
}
